import { AxiosResponse } from 'axios';
import { reportList } from '@/api/report';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IReportApiListResponse, IReportFilters } from '@/types/report';
import { IListParams } from '@/types/service';

export const reportService = {
    async list(params: IListParams<IReportFilters>): Promise<AxiosResponse<IReportApiListResponse>> {
        try {
            return await baseListService<IReportApiListResponse>(reportList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Report API Error:', e);
            throw new AppError('Unable to load report list, request error', { cause: e });
        }
    },
};
